import React, { memo } from 'react'

import { bool, func, node, number, string } from 'prop-types'

import i18n from 'Pods/Shared/I18nThreeDStudio'

import CardFooter from '../CardFooter/CardFooter'
import SubscriptionBullets from '../SubscriptionBullets/SubscriptionBullets'

// Compact teal-tinted subscription upsell shared by the 3D Studio usage modal (via a store-adapter
// wrapper) and the AI subscription landing waitlist modal. All data is injected so the card stays
// store-agnostic.
function UpgradeCard({
  title = 'Upgrade to Keep Creating',
  price = null,
  originalPrice = null,
  monthlyModels = null,
  subscriptionHref,
  learnMoreHref = '#',
  onClose: handleClose,
  locale = 'en',
  advancedFeaturesList = null,
  showAdvancedFeaturesBullet = false,
}) {
  const t = (key, options) => i18n.t(key, { ns: 'three-d-studio', lng: locale, ...options })

  return (
    <section className="usage-modal__upgrade-card">
      <div className="usage-modal__upgrade-card-main">
        <div className="usage-modal__upgrade-card-header">
          <p className="cgt-heading-200">
            {title}
          </p>

          {price && (
            <div className="usage-modal__upgrade-card-price">
              <div className="usage-modal__upgrade-card-price-row">
                {originalPrice && (
                  <span className="usage-modal__upgrade-card-price-original cgt-body-lg-semibold">
                    {originalPrice}
                  </span>
                )}
                <span className="cgt-heading-300">{price}</span>
              </div>
              <span className="usage-modal__upgrade-card-price-unit cgt-caption-semibold">
                {t('usageModal.upgradeCard.priceUnit')}
              </span>
            </div>
          )}
        </div>

        <SubscriptionBullets
          variant="upgrade"
          monthlyModels={monthlyModels}
          locale={locale}
          showAdvancedFeaturesBullet={showAdvancedFeaturesBullet}
        />

        {advancedFeaturesList}

        <CardFooter
          variant="upgrade"
          ctaLabel={t('usageModal.upgradeCard.cta')}
          subscriptionHref={subscriptionHref}
          learnMoreHref={learnMoreHref}
          onClose={handleClose}
        />
      </div>
    </section>
  )
}

UpgradeCard.propTypes = {
  title: string,
  price: string,
  originalPrice: string,
  monthlyModels: number,
  subscriptionHref: string.isRequired,
  learnMoreHref: string,
  onClose: func.isRequired,
  locale: string,
  advancedFeaturesList: node,
  showAdvancedFeaturesBullet: bool,
}

export default memo(UpgradeCard)
